import errorManager from '@/rollbar.js';

const checkForm = function (ev) {
  let errorsCount = 0;
  if (!$('.chech_radio_mail_users[type=checkbox]:checked').length) {
    Utils.appendToFlash('error', $(ev.target).data('noReceiver'));
    errorsCount += 1;
  }
  if ($('#conversation_is_nucleo_true:checked').length && !$('.units_check:checked').length) {
    Utils.appendToFlash('error', $(ev.target).data('noUnit'));
    errorsCount += 1;
  }
  return errorsCount == 0;
};

const comunicazionePersonaleSelected = function () {
  if ($(this).prop('checked')) {
    return $('input.CCN').prop('checked', true);
  } else {
    return $('input.A').prop('checked', true);
  }
};

const moveTr = function () {
  let ids_select = [];
  let ids = [];
  $('.tr_users').each(function () {
    return $(this).hasClass('tr_select') ? ids_select.push(parseInt($(this).attr('id'))) : ids.push(parseInt($(this).attr('id')));
  });
  ids_select = ids_select.sort(function (a, b) {
    return a - b;
  });
  ids = ids.sort(function (a, b) {
    return a - b;
  });
  let last = $('tr#' + ids_select[0]);
  if (last.attr('id') !== $('.tr_users').first().attr('id')) {
    last.insertBefore($('.tr_users').first());
  }
  $.each(ids_select.slice(1), function (i, v) {
    $('tr#' + v).insertAfter(last);
    return (last = $('tr#' + v));
  });
  return $.each(ids, function (i, v) {
    $('tr#' + v).insertAfter(last);
    return (last = $('tr#' + v));
  });
};

const renameAttached = function () {
  var new_filename, old_filename;
  old_filename = $(this).val();
  new_filename = old_filename.trim().replace(/\s/g, '-');
  return $(this).val(new_filename);
};

const reset_users = function () {
  var groups_checked, units_checked;
  $('.users').prop('checked', false);
  $('.tr_users').removeClass('tr_select');
  groups_checked = $('.groups:checked');
  units_checked = $('.units_check:checked');
  if (groups_checked.length === 0 || units_checked.length === 0) {
    $.merge(units_checked, groups_checked).each(function () {
      var id;
      id = $(this).attr('id');
      $('.' + id).prop('checked', true);
      return $('.tr_' + id).addClass('tr_select');
    });
  } else {
    groups_checked.each(function () {
      var group_id;
      group_id = $(this).attr('id');
      return units_checked.each(function () {
        var unit_id;
        unit_id = $(this).attr('id');
        $('.' + group_id + '.' + unit_id).prop('checked', true);
        return $('.tr_' + group_id + '.tr_' + unit_id).addClass('tr_select');
      });
    });
  }
  return moveTr();
};

const initLestener = () => {
  () => {
    return window.i18nJS;
  };
  $(document).on('submit', '#mail_form', checkForm);
  $('#all-ccn').on('click', comunicazionePersonaleSelected);
  $('.groups').on('click', reset_users);
  $('.units_check').on('click', reset_users);
  $('.users').click(function () {
    $(this).is(':checked') ? $(this).parent().parent().addClass('tr_select') : $(this).parent().parent().removeClass('tr_select');
    return moveTr();
  });
  $('#mail_attached').on('focusout', renameAttached);
  // ricerca destinatari
  $('#search_users').fastLiveFilter('.user_tr', { subTxt: 'td:first-child' });
};

const init = () => {
  try {
    initLestener();
  } catch (e) {
    errorManager(e);
  }
};

window.MailNew = {
  init: init,
};
